import React from 'react'

import { useState } from 'react'
import Image from 'next/image'
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { ArrowRight, Code2, Smartphone, Globe, ShoppingCart, Cloud, Users, Brain, Database, Shield, ChevronLeft, ChevronRight } from 'lucide-react'

export default function ProductsServices() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-5xl  font-bold mb-4">
            Bridging Innovation & Excellence
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            We develop cutting-edge solutions and transform existing ones through collaborative development that prioritises your success.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ITservices.map((service, index) => (
            <div className="group relative overflow-hidden rounded-xl cursor-pointer h-[300px]" key={index}>
              <Image
                src={service.image}
                alt={service.title}
                width={600}
                height={400}
                className="object-cover w-full h-full transition-all duration-300 group-hover:scale-110 group-hover:blur-sm"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-black/40 p-6 flex flex-col justify-end transition-all duration-300 group-hover:bg-[#e13944]/80">
                <div className="text-white transform translate-y-32 group-hover:translate-y-0 transition-transform duration-300">
                  <div className="flex items-center gap-2 mb-6">
                    {service.icon}
                    <h3 className="text-lg font-semibold">{service.title}</h3>
                  </div>
                  <div className="overflow-hidden">
                    <p className="text-sm text-gray-200 mb-4">
                      {service.description}
                    </p>
                    <Button
                      variant="outline"
                      className="bg-transparent border-white text-white hover:bg-white hover:text-[#e13944]"
                    >
                      Learn More <ArrowRight className="ml-2 h-4 w-4" />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export const ITservices = [
  {
    title: "Software Development",
    description: "Transforming client needs into software solutions that leverage the latest technologies",
    icon: <Code2 className="h-6 w-6" />,
    image: "/assets/services/software-development.jpg",
    href:"#"
  },
  {
    title: "Mobile App Development",
    description: "Create custom apps from scratch or modernise existing ones to match the latest technology trends",
    icon: <Smartphone className="h-6 w-6" />,
    image: "/assets/services/mobile-app-development.jpg",
    href: "#"
  },
  {
    title: "Web Development",
    description: "Your doorway to the world of the web with customized and user-friendly websites",
    icon: <Globe className="h-6 w-6" />,
    image: "/assets/services/web-development.jpg",
    href: "#"
  },
  {
    title: "E-Commerce Solutions",
    description: "Build robust and user-friendly E-Commerce platforms to maximize your reach",
    icon: <ShoppingCart className="h-6 w-6" />,
    image: "/assets/services/e-commerce.jpg",
    href: "#"
  },
  {
    title: "Cloud Solutions",
    description: "Streamline operations and enhance security with comprehensive cloud implementation",
    icon: <Cloud className="h-6 w-6" />,
    image: "/assets/services/cloud-solutions.jpg",
    href: "#"
  },
  {
    title: "CRM Development",
    description: "Custom CRM software designed to streamline and enhance your business operations",
    icon: <Users className="h-6 w-6" />,
    image: "/assets/services/crm-development.jpg",
    href: "#"
  },
  {
    title: "AI/ML Solutions",
    description: "Boost performance with advanced AI/ML technologies and deep learning",
    icon: <Brain className="h-6 w-6" />,
    image: "/assets/services/aiml-solutions.jpg",
    href: "#"
  },
  {
    title: "Data Engineering",
    description: "Ensure seamless data processing and analytics for better decision making",
    icon: <Database className="h-6 w-6" />,
    image: "/assets/services/data-engineering.jpg",
    href: "#"
  },
  {
    title: "Cyber Security",
    description: "Protect your digital assets with comprehensive security services",
    icon: <Shield className="h-6 w-6" />,
    image: "/assets/services/cyber-security.jpg",
    href: "#"
  },
]